import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.20378 13.0866L10.4841 0.945891C10.9343 0.0755836 11.9836 -0.253694 12.8279 0.210428C13.3924 0.520797 13.745 1.12668 13.745 1.78626V8.05495C13.745 8.19586 13.8558 8.31008 13.9925 8.31008H18.2676C19.2244 8.31008 20 9.10966 20 10.096C20 10.3903 19.9294 10.6801 19.7945 10.9396L13.495 23.0574C13.043 23.9267 11.993 24.2538 11.1498 23.7878C10.587 23.4769 10.2357 22.872 10.2357 22.2137V15.968C10.2357 15.8271 10.1249 15.7128 9.98823 15.7128H5.73236C4.7756 15.7128 4 14.9133 4 13.9269C4 13.6338 4.06998 13.3452 4.20378 13.0866ZM12.2602 1.78619C12.2602 1.69196 12.2098 1.60541 12.1291 1.56107L12.0669 1.53719C11.9609 1.51259 11.8479 1.56253 11.7943 1.66613L5.51397 13.8068C5.49486 13.8438 5.48486 13.885 5.48486 13.9269C5.48486 14.0678 5.59566 14.182 5.73234 14.182H9.98821C10.945 14.182 11.7206 14.9816 11.7206 15.9679V22.2137C11.7206 22.3077 11.7707 22.3941 11.8511 22.4385C11.9716 22.5051 12.1216 22.4584 12.1862 22.3342L18.4858 10.2164C18.505 10.1794 18.5151 10.138 18.5151 10.0959C18.5151 9.95501 18.4043 9.84079 18.2676 9.84079H13.9925C13.0358 9.84079 12.2602 9.04121 12.2602 8.05488V1.78619Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }